import React from 'react';
import { Handshake } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../../shared/LibrarySection';
import { useNavigate } from 'react-router-dom';
import { PhysicianGroupTable } from './PhysicianGroupTable';

export const PhysicianGroupLibrarySection = {
	settingsView: 'physician-groups',
	title: 'Physician Groups',
	description: 'Manage physician groups and their members',
	TitleIcon: Handshake
} satisfies SettingsSectionItem;

export function PhysicianGroupLibrary() {
	const navigate = useNavigate();

	const handleAdd = () => {
		navigate('add');
	};

	return (
		<LibrarySection
			librarySection={PhysicianGroupLibrarySection}
			handleAdd={handleAdd}
			addLabel="Add Physician Group"
			searchPlaceholder="Search physician groups by name..."
			noResultsLabel="No Physician Groups Found"
			noResultsSubLabel="Get started by adding your first physician group"
			TableComponent={PhysicianGroupTable}
		/>
	);
}
